module.exports = __webpack_public_path__ + "img/search_btn.45983741.svg";